import { render, staticRenderFns } from "./ModalHistoryCatatanProyek.vue?vue&type=template&id=546bdfe8&scoped=true"
import script from "./ModalHistoryCatatanProyek.vue?vue&type=script&lang=js"
export * from "./ModalHistoryCatatanProyek.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoryCatatanProyek.vue?vue&type=style&index=0&id=546bdfe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bdfe8",
  null
  
)

export default component.exports